import { mapGetters, mapMutations } from 'vuex';

const filtersMixin = {
	methods: {
		...mapMutations(['updateFilters']),
		saveFilters(column, params = {}) {
			this.updateFilters(
				Object.assign(this.filters(column), {
					column: column,
					row: null,
					rules: {
						...params,
					},
				})
			);
		},
		filters(column) {
			return this.getFilters(column) || {};
		},
		columnType(column) {
			return (this.filters(column).rules || {}).type;
		},
		columnSelectedCurrency(column) {
			return (this.filters(column).rules || {}).currency;
		},
		isNumericColumn(column) {
			return ['integer', 'decimal', 'decimal-precise', 'currency'].includes(this.columnType(column));
		},
		valueRequired(column) {
			return (this.filters(column).rules || {}).required;
		},
	},
	computed: {
		...mapGetters(['getFilters']),
	},
};

export default filtersMixin;
